import React from "react"
import Container from "./IconContainer"


const HoursIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-465.000000, -1423.000000)"
          stroke="#505050"
          strokeWidth="1.5"
        >
          <g id="Group-6" transform="translate(466.000000, 1424.000000)">
            <circle id="Oval" cx="7" cy="7" r="7" />
            <polyline id="Shape" points="7 3 7 7 9 9" />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default HoursIcon


// WEBPACK FOOTER //
// ./assets/common/components/icons/HoursIcon.js